import React from "react";

import Benefits from "./Benefits";
import DescribeIdea from "./DescribeIdea";
import Issues from "./Issues";
import "./styles.css";

const DependencyModalTabs = ({ currentTab, ...props }) => {
  return (
    <>
      {currentTab === 0 && (
        <DescribeIdea
          addUploadedImageToLibrary={props.addUploadedImageToLibrary}
          selectCurrentDependencyImageFromLibrary={props.selectCurrentDependencyImageFromLibrary}
          removeImageFromLibrary={props.removeImageFromLibrary}
          dependency={props.dependency}
          handleChange={props.handleChange}
          uploadInfo={props.uploadInfo}
          newGeneratedImage={props.newGeneratedImage}
          handleCancelClick={props.handleCancelClick}
          handleFileSelect={props.handleFileSelect}
          isLoadingImage={props.isLoadingImage}
          productType={props.productType}
          header={props.header}
          handleGenerateNames={props.handleGenerateNames}
          openGenerateNameModal={props.openGenerateModal}
          closeGenerateNameModal={props.closeGenerateModal}
          suggestedNamesForIdeas={props.suggestedOptions}
          suggestedLoading={props.suggestedLoading}
          addIdeasName={props.addIdeasName}
          reversed={props.reversed}
          handleAcceptPotentialImage={props.handleAcceptPotentialImage}
          potentialGeneratedImageUrl={props.potentialGeneratedImageUrl}
          handleGenerateImage={props.handleGenerateImage}
          isOpenGenerateImageModal={props.isOpenGenerateImageModal}
          closeDialogGenerateImage={props.closeDialogGenerateImage}
          generatedImage={props.generatedImage}
        />
      )}

      {currentTab === 1 && (
        <Benefits
          benefits={props.dependency.benefits}
          addBenefit={props.addBenefit}
          removeBenefit={props.removeBenefit}
          removeLastBenefit={props.removeLastBenefit}
          handleBenefitChange={props.handleBenefitChange}
          handleTargetChange={props.handleTargetChange}
          customCategories={props.customCategories}
          score={props.dependency.score}
          handleChangeScore={props.handleChangeScore}
          handleGenerateBenefits={props.handleGenerateBenefits}
          openGenerateBenefitsModal={props.openGenerateModal}
          closeGenerateBenefitsModal={props.closeGenerateModal}
          suggestedLoading={props.suggestedLoading}
          suggestedBenefits={props.suggestedOptions}
          addGenerateBenefits={props.addGenerateBenefits}
          selectGenerateOption={props.selectGenerateOption}
          selectedGenerateOptions={props.selectedGenerateOptions}
          userFullName={props.userFullName}
          handleDeleteOption={props.handleDeleteOption}
          handleRenameOption={props.handleRenameOption}
          addCustomCategory={props.addCustomCategory}
        />
      )}

      {currentTab === 2 && (
        <Issues
          issues={props.dependency.issues}
          userId={props.userId}
          reversed={props.reversed}
          userFullName={props.userFullName}
          messages={props.dependency.issuesMessages}
          addIssue={props.addIssue}
          removeIssue={props.removeIssue}
          removeLastIssue={props.removeLastIssue}
          removeMessage={props.removeMessage}
          removeLastMessage={props.removeLastMessage}
          handleChange={props.handleIssueChange}
          addIssueMessage={props.addIssueMessage}
          handleIssueMessageChange={props.handleIssueMessageChange}
          feasibleScore={props.dependency.feasibleScore}
          handleChangeFeasibleScore={props.handleChangeFeasibleScore}
          handleGenerateChallenges={props.handleGenerateChallenges}
          openGenerateChallengesModal={props.openGenerateModal}
          closeGenerateChallengesModal={props.closeGenerateModal}
          suggestedChallenges={props.suggestedOptions}
          suggestedLoading={props.suggestedLoading}
          addGenerateChallenges={props.addGenerateChallenges}
          selectGenerateOption={props.selectGenerateOption}
          selectedGenerateOptions={props.selectedGenerateOptions}
        />
      )}
    </>
  );
};

export default DependencyModalTabs;
